import {React} from 'react';
import Header from './common/Header';



function InternetError(){
   
    return(
      <> <Header/>
        <div>
         
          <img src='./internet_dis.jpg' className='page_not_found_img'></img>
        </div>
        </>
    )
}

export default InternetError;